import { TransactionalEvent } from '@shared/interfaces/transactional-event';
import { Observable } from 'rxjs';

export const TRANSACIONAL_EVENTS_REPOSITORY = 'TransactionalEventsRepository';

export interface TransactionalEventsRepository {
  url: string;

  getItems(): Observable<any>;

  add(transactionalEvent: TransactionalEvent): Observable<any>;

  edit(transactionalEvent: TransactionalEvent): Observable<any>;

  delete(item: any): Observable<any>;
}
